/* Pivot theme · © 2026 The Pivot Edit. All rights reserved. */
(function () {
  // Product gallery: click a thumbnail to swap the main image.
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-src');
        main.removeAttribute('srcset');
        g.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  });
  // Close the mobile menu when a link is chosen.
  document.querySelectorAll('.mobile-nav a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details'); if (d) d.removeAttribute('open');
    });
  });
})();
